import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getAliases } from "../../../common/services/products/aliasService";
import SearchBox from "../../../common/components/search/searchBox";
import AliasesTable from "./aliasesTable";
import { withTranslation } from "react-i18next";

class Aliases extends Component {
  constructor(props) {
    super(props);

    this.handleAliasUpdated = this.handleAliasUpdated.bind(this);
  }

  state = {
    aliases: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "name", order: "asc" },
    isLoading: true,
  };

  async componentDidMount() {
    this.setState({ aliases: await getAliases(), isLoading: false });
  }

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSort = (colId, sort) => {
    if (colId && sort) {
      this.setState({
        sortColumn: {
          path: colId,
          order: sort,
        },
      });
    }
  };

  handleToggleActiveOnly = () => {
    this.setState({ activeOnly: !this.state.activeOnly });
  };

  handleAliasSelected = (alias, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(alias, this.handleAliasUpdated, isNew);
  };

  handleAliasUpdated = (alias) => {
    const aliases = [...this.state.aliases];
    const index = aliases.findIndex((u) => u.aliasId === alias.aliasId);
    if (index > -1) {
      aliases.splice(index, 1);
    }
    aliases.push(alias);
    this.setState({ aliases: aliases });
  };

  getFilteredData = () => {
    const {
      sortColumn,
      searchQuery,
      aliases: allAliases,
      activeOnly,
    } = this.state;

    let filtered = allAliases;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          u.name != null &&
          u.name.toLowerCase().includes(searchQuery.toLowerCase())
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: filtered.length, data: sorted };
  };

  render() {
    const { searchQuery, activeOnly, isLoading } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const { totalCount, data: aliases } = this.getFilteredData();

    const newAlias = {
      aliasId: uuid(),
      name: t("NewAlias"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() => this.handleAliasSelected(newAlias, true)}
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddAlias")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedAlias", { count: totalCount })}</p>
        <AliasesTable
          aliases={aliases}
          onSort={this.handleSort}
          onRowClick={this.handleAliasSelected}
        />
      </div>
    );
  }
}

export default withTranslation(["products"])(Aliases);
